<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" >
      <b-col md="10" lg="8" xl="6">
        <b-card>
          <div slot="header">{{$route.meta.label}}
            <div class="card-header-actions">
              <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="print()">
                <i class="fa fa-print"></i> Print
              </button>
              <b-button class="btn btn-danger mr-1" @click="close()">
                <i class="fa fa-close"></i> Batal
              </b-button>
            </div>
          </div>

          <b-input-group>
            <b-input-group-prepend><label >Tanggal Kirim</label></b-input-group-prepend>
            <b-form-input
              class="col-md-6"
              v-model="model.tanggal"
              type="date"
              :state="!$v.model.tanggal.$error"
            ></b-form-input>
          </b-input-group>
            <h6 style="margin-top:0.5rem !important; margin-bottom:0 !important;">Eksemplar per Koli per Section</h6>
              <b-row no-gutters>
                <b-col cols="3">
                </b-col>
                <b-col cols="3">
                  <strong>Normal</strong>
                </b-col>
                <b-col cols="3">
                  <strong>Minimum</strong>
                </b-col>
                <b-col cols="3">
                  <strong>Tolerasi</strong>
                </b-col>
              </b-row>
              <span v-for="(input,index) in model.sections" :key="index">
                <b-row>
                  <b-col cols="3" class="text-right">
                    <strong>Section #{{index+1}}</strong>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input v-model="input.koliNormal"></b-form-input>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input v-model="input.koliMinimum"></b-form-input>
                  </b-col>
                  <b-col cols="3">
                    <b-form-input v-model="input.koliTolerance"></b-form-input>
                  </b-col>
                </b-row>
              </span>

          <b-row no-gutters>
            <b-col lg="7">  
              <b-input-group>
                <b-form-radio v-model="filterAgenJurusan"  value="JURUSAN" class="pt-2">Pilih Jurusan </b-form-radio>                
                <b-form-input v-model="findJurusan" placeholder="masukkan nama/kode jurusan" v-if="(filterAgenJurusan=='JURUSAN')"></b-form-input>
                <b-input-group-append>
                    <b-button class="btn btn-secondary" @click="clearFilter()" v-if="(filterAgenJurusan=='JURUSAN')" ><i class="fa fa-close"></i></b-button>               
                </b-input-group-append>
                <b-form-invalid-feedback style="display:unset; font-size: 90%;" v-show="isRequiredJurusan">Pilih minimal 1 jurusan.</b-form-invalid-feedback>
              </b-input-group>
            </b-col>
            <b-col lg="5">  
            </b-col>
          </b-row>  
          <b-card v-if="(filterAgenJurusan=='JURUSAN')">
              <b-form-checkbox-group
                id="checkbox-group-2" size="sm" 
                v-model="jurusanSelected"
              >
                <b-form-checkbox
                  v-for="item in koranjurusan"
                  :value="item.jurusan_id"
                  :key="item.index"
                  class="col-5 text-small" 
                >{{item.jurusan_code+' | '+item.jurusan_name}}</b-form-checkbox>
              </b-form-checkbox-group>
                <b-row class="justify-content-center mb-0">
                  <button class="btn btn-primary mr-1" @click.stop.prevent="pilihJurusan(1)">
                    <i class="fa fa-check-square"></i> Pilih Semua
                  </button>
                  <b-button class="btn btn-primary mr-1" @click.stop.prevent="pilihJurusan(0)">
                    Bersihkan Pilihan
                  </b-button>
                </b-row>

          </b-card>
        </b-card>
      </b-col>
    </b-row>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>



<script>
import { validationMixin } from "vuelidate";
import { required, minValue, minLength } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
import moment from "moment";
import Loading from "vue-loading-overlay";
import crud from "../../apis/crud";
import koran_report from "../../apis/koran_report";

toastr.init();

export default {
  components: { Loading },
  mixins: [validationMixin],
  validations: {
    model: {
      tanggal: { required },
    }
  },
  data() {
    return {
      isLoading: false,
      horizontal: true,
      saveEnabled: true,
      lkuKoranCustShow: false,
      lkuKoranSalesShow: false,
      lkuKoranColectorShow: false,
      showTableKirimTitipan: false,
      filterAgenJurusan:'AGEN',
      model: {
        tanggal: null,
        sections: [
          {
            section_no: 1,
            koliNormal: 0,
            koliMinimum: 0,
            koliTolerance: 0
          },
          {
            section_no: 2,
            koliNormal: 0,
            koliMinimum: 0,
            koliTolerance: 0
          },
          {
            section_no: 3,
            koliNormal: 0,
            koliMinimum: 0,
            koliTolerance: 0
          },
          {
            section_no: 4,
            koliNormal: 0,
            koliMinimum: 0,
            koliTolerance: 0
          }
        ],
        jurusanId: []
      },
      allJurursan: false,
      findJurusan: "",
      findPercetakan: "",
      koranjurusanRec: [],
      koranjurusan: [],
      jurusanSelected: [],
      showReport: false,
      reportUrl: null,
      isRequiredJurusan: false,
      options_section_no: [
        { value: null, text: "Pilih Section", disabled: true },
        { value: 1, text: "Sect. 1" },
        { value: 2, text: "Sect. 2" },
        { value: 3, text: "Sect. 3" },
        { value: 4, text: "Sect. 4" }
      ]
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    renderJurusan() {
      return {
        findJurusan: this.findJurusan.trim() || "",
        findPercetakan: this.findPercetakan.trim() || ""
      };
    },
    needJurusan(val) {
      return {
        jurusan: this.model.jurusanId,
        customer_id: this.model.customer_id
      };
    },
    getSetinganKoli() {
      return { section_no: this.model.section_no, tanggal: this.model.tanggal };
    }
  },
  watch: {
    renderJurusan(val) {
      const { findJurusan, findPercetakan } = val;
      if (findJurusan === "" && findPercetakan === "") {
        this.koranjurusan = JSON.parse(JSON.stringify(this.koranjurusanRec));
        // const jrs = this.koranjurusan.map(x => x.jurusan_id);
        // this.jurusanSelected = jrs;
        // this.allJurursan = true;
      } else {
        let result = JSON.parse(JSON.stringify(this.koranjurusanRec));

        result = result.filter(function(x) {
          const txtNameJrs = x.jurusan_name.toUpperCase();
          const txtKodeJrs = x.jurusan_code.toUpperCase();
          const findJurusanTxt = findJurusan.toUpperCase();
          return (
            txtNameJrs.indexOf(findJurusanTxt) !== -1 ||
            txtKodeJrs.indexOf(findJurusanTxt) !== -1
          );
        });

        // result = result.filter(function(x) {
        //   const txtPercetakan = x.percetakan_name.toUpperCase();
        //   const findPercetakanTxt = findPercetakan.toUpperCase();
        //   return txtPercetakan.indexOf(findPercetakanTxt) !== -1;
        // });

        // const jrs = result.map(x => x.jurusan_id);
        // this.allJurursan = true;
        // this.jurusanSelected = jrs;
        this.koranjurusan = result;
      }
    },
    needJurusan({ jurusan = [], customer_id }) {
      if (jurusan.length > 0) {
        this.isRequiredJurusan = false;
      } else {
        if (customer_id !== "") {
          this.isRequiredJurusan = false;
        } else {
          this.isRequiredJurusan = true;
        }
      }
    },
    async getSetinganKoli(obj) {
      const { section_no, tanggal } = obj;
      if (tanggal !== null && section_no !== null) {
        const resp = await koran_report.getKoranSetingan(obj);
        const data = resp[0];
        if (data) {
          this.model.koliNormal = data.qty_normal || 0;
          this.model.koliMinimum = data.qty_minimum || 0;
          this.model.koliToleransi = data.qty_tolerance || 0;
        } else {
          this.model.koliNormal = 0;
          this.model.koliMinimum = 0;
          this.model.koliToleransi = 0;
        }
      }
    }
  },
  created: async function() {
    const [a] = await Promise.all([
      crud.list({ tablename: "vwkoranjurusan", limit: 1000 })
    ]);
    this.koranjurusanRec = a;
    this.koranjurusan = JSON.parse(JSON.stringify(this.koranjurusanRec));
  },
  methods: {
    pilihJurusan(val) {
      if (val) {
        this.koranjurusan.forEach(element => {
          this.jurusanSelected.push(element.jurusan_id);
        });
        this.allJurursan=true;
      } else {
        this.jurusanSelected = [];
        this.allJurursan=false;
      }
    },    
    print: async function() {
      if (this.filterAgenJurusan=='AGEN') {
        this.model.jurusanId = '';
      } else {
        //  this.model.jurusanId = JSON.stringify(this.jurusanSelected);
         this.model.jurusanId = this.jurusanSelected.join(',');
      }
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else if (this.isRequiredJurusan) {
        toastr.error("Harap pilih jurusan.", "ERROR MESSAGE");
      } else {
        try {
          this.isLoading = true;
          const data = JSON.parse(JSON.stringify(this.model));
          data.tanggal=moment(this.model.tanggal).format('YYYY-MM-DD');
          // console.log('data.sections: ',data.sections);
          const resp = await koran_report.suratJalanKoli(data) ;
          this.isLoading = false;
          this.reportUrl = resp;
          this.showReport =true;
        } catch (error) {
          this.isLoading = false;
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }   
        }
      }
    },

    clearFilter: function() {
      this.findJurusan = "";
      this.findPercetakan = "";
    },
    close() {
      router.push({ name: "koran.home" });
    },
    clearModel() {}
  }
};
</script>